(function( $ ) {

    $('document').ready(function(){
        $(document).on("click", ".flights__tabs .nav-link.active", function(){
            $(".tabs__list .tab-pane").removeClass('show active');
            $(this).removeClass('active');
            $(".flights__tabs .nav-item .nav-link").removeClass("removeHover");

            var navLinks = $(".flights__tabs .nav-item .nav-link");
            navLinks.removeClass("removeHover");
            navLinks.closest('.nav-pills').removeClass('removeShadow');
        });

        $(document).on("click", ".flights__tabs .nav-link:not(.active)", function(){
            $(".flights__tabs .nav-item .nav-link").addClass("removeHover");
            var navLinks = $(".flights__tabs .nav-item .nav-link");
            navLinks.closest('.nav-pills').addClass('removeShadow');
        });

        $(function() {
            const { __, _x, _n, _nx } = wp.i18n;

            const $flights_tabs_form = $('#flights_tabs_form');

            /**
             * Destinations List Array
             */
            var data_dest = $flights_tabs_form.attr('data-dest');

            if (data_dest !== "" && typeof data_dest !== 'undefined') {
                data_dest = JSON.parse(data_dest);

                const destinationsList = [];

                $.each(data_dest, function(index, value) {
                    destinationsList.push(value);
                });

                $flights_tabs_form.find("#from-destination").autocomplete({
                    source: destinationsList,
                    change: function(event, ui) {
                        if (ui.item == null) {
                            event.currentTarget.value = '';
                            event.currentTarget.focus();
                        }
                    }
                });
                $flights_tabs_form.find("#to-destination").autocomplete({
                    source: destinationsList,
                    change: function(event, ui) {
                        if (ui.item == null) {
                            event.currentTarget.value = '';
                            event.currentTarget.focus();
                        }
                    }
                });
            }

            if ($flights_tabs_form.length && typeof $.validator !== 'undefined') {
                $.validator.addMethod("flightNoRegex", function(value, element) {
                    return this.optional(element) || /^([a-zA-Z0-9]+)$/i.test(value);
                }, "Flight number must contain only numbers and letters.");

                $flights_tabs_form.validate({
                    rules: {
                        arr_destination: {
                            require_from_group: [1, ".search-group"]
                        },
                        flight_no: {
                            require_from_group: [1, ".search-group"],
                            minlength: 2,
                            maxlength: 7,
                            regexFlightNo: true
                        }
                    },
                    messages: {
                        arr_destination: {
                            require_from_group: __( 'At least one field is required' ,  'sofia-airport' ),
                        },
                        flight_no: {
                            require_from_group: __( 'At least one field is required' ,  'sofia-airport' ),
                            flightNoRegex: __( 'Flight number must contain only numbers and letters.' ,  'sofia-airport' ),
                            minlength: __( 'Wrong flight number' ,  'sofia-airport' ),
                            maxlength: __( 'Wrong flight number' ,  'sofia-airport' ),
                        }
                    },
                    submitHandler: function(form) {
                        $('#flights_tabs_form')[0].submit();
                    }
                })
            }
        });
    });
})( jQuery );